var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReport24DpE3E3E3Fill0Wght400Grad0Opsz24 = function SvgReport24DpE3E3E3Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e3e3e3",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-280q17 0 28.5-11.5T520-320t-11.5-28.5T480-360t-28.5 11.5T440-320t11.5 28.5T480-280m-40-160h80v-240h-80zM330-120 120-330v-300l210-210h300l210 210v300L630-120zm34-80h232l164-164v-232L596-760H364L200-596v232zm116-280"
  })));
};
export default SvgReport24DpE3E3E3Fill0Wght400Grad0Opsz24;